import React from 'react';
import PropTypes from 'prop-types';

export default class CheckboxInput extends React.Component {

    render() {
        return (
            <label className="checkbox">
                {this.props.title && <span className="sub-title text--grey">{this.props.title}</span>}
                <input type="checkbox" name={this.props.name} onChange={(event) => this.props.onChange(event)} checked={this.props.isChecked} required={this.props.required} disabled={this.props.disabled} />
                <span className="tick">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.1 15.6" className="icon">
                        <path className="path--color"
                              d="M6.4 9.9L2.8 6.4 0 9.2l4.9 4.9 1.5 1.5L19.1 2.8 16.3 0z"/>
                    </svg>
                </span>
                <span className="checkbox__text">{this.props.label}</span>
                {this.props.error && <span className="error text--red">{this.props.error}</span>}
                {!this.props.error && this.props.warning && <span className="error text--warning">{this.props.warning}</span>}
            </label>
        )
    }
}

CheckboxInput.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    error: PropTypes.string,
    required: PropTypes.bool,
    onChange: PropTypes.func,
    isChecked: PropTypes.bool,
    disabled: PropTypes.bool,
};
